import { observable, action, toJS, runInAction } from "mobx";
import { message } from "antd";
import { imgToPdf } from "imgtopdf";
import moment from "moment";

class Store {
    @observable visible = false;
    @observable loading = false;

    @observable data = {
        billing_addr: "",
        billing_tel: "",
        billing_name: "",
        email: "",  //接受者邮箱
        name: "",  //接收人
        tel: "",  //接收人电话
        addr: "", //地址
        out_trade_no: "", //订单编号
        hotel_name: "", //酒店名称
        add_time: "", //申请时间
        current_time: "", //当前过期时间 
        expire_date: "", //付费后过期时间 
        account: "",  //申请账号
        money: "9600.00",
        current_time: moment().format('YYYY-MM-DD'),
        expire_date: moment().add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD')
    };

    @action
    onChange = (name, value = '') => {
        this.data[name] = value;
    }

    @action
    onShow = (data, hotel) => {
        const hotelName = data.billing_invoice || sessionStorage.getItem('hotelName') || hotel.name;
        const account = JSON.parse(sessionStorage.getItem('user') || "{}")['email'] || "";
        console.log(data);
        this.data = {
            ...this.data,
            name: data.name || "",
            tel: data.tel || '',
            addr: data.addr || "",
            billing_name: data.billing_name || "",
            billing_tel: data.company_phone || data.billing_tel || '',
            billing_addr: data.company_addr || data.billing_addr || "",
            out_trade_no: data.out_trade_no || "",
            hotel_name: data.billing_invoice || hotelName,
            add_time: moment(data.add_time || null).format('YYYY-MM-DD'),
            current_time: data.current_time || "",
            expire_date: data.expire_date || "",
            account: account == 'admin' ? (hotel.code || "") + "_FIN" : account,
            money: data.money || "9600",
            current_time: moment(data.current_time || null).format('YYYY-MM-DD'),
            expire_date: moment(data.current_time || null).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD')
        };
        this.visible = true;
    }

    @action
    onCancel = () => {
        if (this.loading) {
            return
        }

        this.visible = false;
        this.clearData();
    }

    @action
    onOk = async type => {
        const data = toJS(this.data);
        // if (!(/^1[3456789]\d{9}$/.test(data.billing_tel)) && !/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(data.billing_tel)) {
        //     message.error('请输入正确的电话号码!');
        //     return
        // }

        const test = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!test.test(data.email)) {
            message.error('请输入正确的邮箱!');
            return
        }

        if (!data.billing_name) {
            message.error('姓名不能为空!');
            return
        }

        if (!data.hotel_name) {
            message.error('单位名称不能为空!');
            return
        }
        if (type == 2 && (!data.addr || !data.tel || !data.name)) {
            message.error('您申请的是纸质合同，请填写收件信息!');
            return
        }

        this.loading = await true;
        try {
            const img = await imgToPdf('contract', 2);
            let dataFrom = new FormData();
            dataFrom.append('img', img.img || "");
            // 2 纸质合同  1电子合同
            dataFrom.append('type', type);

            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    if (data[key] && data[key].includes('time')) data[key] = moment(data[key]).format('YYYY-MM-DD');
                    dataFrom.append(key, data[key] || "");
                }
            }

            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }
            const json = await fetch('/applycontract', headres);
            const d = await json.json();

            this.loading = await false;

            if (d.status == 1) {
                message.info('合同发送成功，请注意查收');
                this.onCancel();
                return
            }

            message.error('邮件发送失败，请重新发送！');
        } catch (error) {
            this.loading = await false;
            message.error('系统处理错误，请重新申请！');
            console.error(error);
        }
    }
    @action clearData = () => {
        this.data = {
            email: "",
            name: "",
            tel: "",
            addr: "",
            out_trade_no: "",
            hotel_name: "",
            add_time: "",
            current_time: "",
            expire_date: "",
            account: ""
        };
    }
}

const applybilling = new Store();

export default applybilling;


// WEBPACK FOOTER //
// ./src/components/user/ApplicationContract/store.js